var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgScJohnsonLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 109.257,
    height: 36,
    viewBox: "0 0 109.257 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4668",
    "data-name": "Rectangle 4668",
    width: 109.257,
    height: 36,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_28889",
    "data-name": "Group 28889",
    transform: "translate(-1624 -201)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_28888",
    "data-name": "Group 28888",
    transform: "translate(1624 201)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_28887",
    "data-name": "Group 28887",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_140204",
    "data-name": "Path 140204",
    d: "M102.406,26.6h1.919V16.41a2.972,2.972,0,0,0-3.044-3.11H94.2V26.535h3.706V16.344a1.191,1.191,0,0,1,2.382,0v8.338s-.265,2.118,2.118,1.919",
    transform: "translate(-31.862 -4.499)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_140205",
    "data-name": "Path 140205",
    d: "M158.04,26.6h1.919V16.41a2.972,2.972,0,0,0-3.044-3.11H149.9V26.535h3.706V16.344a1.191,1.191,0,1,1,2.382,0v8.338c-.066,0-.331,2.118,2.051,1.919",
    transform: "translate(-50.701 -4.499)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_140206",
    "data-name": "Path 140206",
    d: "M84,22.1h1.919V11.912A2.972,2.972,0,0,0,82.878,8.8H79.635V0H75.4V22.1h4.169V11.846a1.191,1.191,0,0,1,2.382,0v8.338c-.066,0-.331,2.118,2.051,1.919",
    transform: "translate(-25.503 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_140207",
    "data-name": "Path 140207",
    d: "M35.086,20.112V18.854H31.513a1.713,1.713,0,0,0-1.721,1.919v.265a2.251,2.251,0,0,1-.066.662,1.394,1.394,0,0,1-1.059.86h-.132a.984.984,0,0,1-.4-.066,1.351,1.351,0,0,1-.993-1.324v-9.2a1.414,1.414,0,0,1,.529-1.125l.4-.2a.839.839,0,0,1,.4-.066h.2c.132,0,.2.066.331.066a1.384,1.384,0,0,1,.4.265,1.359,1.359,0,0,1,.463,1.059v.2c0,1.522,1.588,1.588,1.721,1.588h3.574v-.6a6.434,6.434,0,0,0-.066-1.191,6.867,6.867,0,0,0-.2-.794,3.033,3.033,0,0,0-.728-1.191A3.834,3.834,0,0,0,32.9,9.06a9.234,9.234,0,0,0-4.037-.86h-.926c-.86,0-5.1.132-6.022,3.044v.2c0,.066-.066.132-.066.265a.984.984,0,0,0-.066.4v.066c-.066.265,0,1.588,0,2.118v6.287a8.764,8.764,0,0,0,.132,1.059c.86,2.912,4.566,3.243,6.088,3.243h1.059a10.229,10.229,0,0,0,3.507-.662A4.087,4.087,0,0,0,34.888,22.1a5.724,5.724,0,0,0,.2-1.985",
    transform: "translate(-7.358 -2.774)",
    fill: "#de2626"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_140208",
    "data-name": "Path 140208",
    d: "M6.218,8.293c-2.316,0-4.037.463-5.029,1.456a2.845,2.845,0,0,0-.926,1.919v2.581a3.358,3.358,0,0,0,1.853,2.912c.993.662,3.9.6,4.037.6a2.129,2.129,0,0,1,1.456.6,1.06,1.06,0,0,1,.265.794v1.787a1.864,1.864,0,0,1-.463,1.39,1.809,1.809,0,0,1-1.191.331h-.2a4.56,4.56,0,0,1-.529-.2,1.766,1.766,0,0,1-.6-1.39v-.4a1.644,1.644,0,0,0-1.456-1.787H.2v.6A5.026,5.026,0,0,0,1.52,23.448a6.927,6.927,0,0,0,4.765,1.588h.463c2.316.066,3.971-.463,4.963-1.456a3.281,3.281,0,0,0,.926-2.051V18.948a3.358,3.358,0,0,0-1.853-2.912c-.993-.662-3.9-.6-4.037-.6a2.129,2.129,0,0,1-1.456-.6,1.06,1.06,0,0,1-.265-.794V12.264a1.864,1.864,0,0,1,.463-1.39,1.467,1.467,0,0,1,1.191-.331,1.4,1.4,0,0,1,1.059.4,1.428,1.428,0,0,1,.265,1.125c0,1.853,1.456,1.853,1.456,1.853h3.375v-.066a5.026,5.026,0,0,0-1.324-3.971C9.527,8.029,6.285,8.293,6.218,8.293",
    transform: "translate(-0.064 -2.801)",
    fill: "#de2626"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_140209",
    "data-name": "Path 140209",
    d: "M121.33,14.553A6.15,6.15,0,0,0,117.16,13.3a5.66,5.66,0,0,0-4.037,1.191,2.346,2.346,0,0,0-.728,1.522V18.06a2.642,2.642,0,0,0,1.522,2.316c.794.529,3.11.463,3.243.463a1.642,1.642,0,0,1,1.191.463.824.824,0,0,1,.2.662V23.42a1.284,1.284,0,0,1-.331,1.059,1.421,1.421,0,0,1-.993.265h-.132a.709.709,0,0,1-.4-.132,1.28,1.28,0,0,1-.463-1.059v-.331a1.322,1.322,0,0,0-1.191-1.456H112.4v.463a3.975,3.975,0,0,0,1.059,3.176,5.83,5.83,0,0,0,3.838,1.257h.4a5.478,5.478,0,0,0,3.971-1.191,2.281,2.281,0,0,0,.728-1.654V21.766a2.642,2.642,0,0,0-1.522-2.316c-.794-.529-3.11-.463-3.243-.463a1.971,1.971,0,0,1-1.191-.463.824.824,0,0,1-.2-.662V16.406a1.284,1.284,0,0,1,.331-1.059,1.422,1.422,0,0,1,.993-.265.9.9,0,0,1,.794.331,1.309,1.309,0,0,1,.2.86,1.352,1.352,0,0,0,1.191,1.522h2.713v-.066a4.063,4.063,0,0,0-1.125-3.176",
    transform: "translate(-38.013 -4.494)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_140210",
    "data-name": "Path 140210",
    d: "M35.206,0V25.147c0,6.949-6.949,10.787-16.61,10.787C6.221,35.934,0,31.434,0,25.61V24.022H4.566c1.853,0,2.25,2.581,2.25,2.581a11.542,11.542,0,0,0,.4,1.456c.993,3.64,6.221,6.088,11.382,6.088,6.419,0,11.118-4.037,11.118-9V0Z",
    transform: "translate(0 0)",
    fill: "#de2626"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_140211",
    "data-name": "Path 140211",
    d: "M54.293,52.912a.874.874,0,0,1-.993-.86.942.942,0,0,1,.6-.86,3.934,3.934,0,0,1,1.125-.132h.132v-.132c0-.4-.132-.529-.529-.529-.331,0-.463.132-.529.463h-.728c0-.6.4-.86,1.191-.86.86,0,1.324.331,1.324.993v1.919h-.662v-.4a1.2,1.2,0,0,1-.926.4m.662-1.456c-.662,0-.926.132-.926.529a.418.418,0,0,0,.463.463c.463,0,.662-.265.662-.86v-.066a.243.243,0,0,0-.2-.066",
    transform: "translate(-18.028 -16.912)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_140212",
    "data-name": "Path 140212",
    d: "M59.324,51.479c0,.331.132.463.4.463h.331v.463a3.039,3.039,0,0,1-.662.066.809.809,0,0,1-.6-.2.956.956,0,0,1-.2-.728V50.09H58V49.56h.6V49.1l.728-.4v.86h.728v.529h-.728Z",
    transform: "translate(-19.618 -16.472)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_140213",
    "data-name": "Path 140213",
    d: "M67.5,52.779h-.86l-.662-1.985-.662,1.985h-.86L63.4,50h.86l.662,1.919L65.584,50h.86l.662,1.919L67.768,50H68.5Z",
    transform: "translate(-21.444 -16.912)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_140214",
    "data-name": "Path 140214",
    d: "M72.956,52.912A1.39,1.39,0,0,1,71.5,51.456a1.491,1.491,0,1,1,1.456,1.456m.066-2.449c-.463,0-.662.331-.662.926,0,.662.265.993.662.993s.662-.331.662-.926c0-.662-.265-.993-.662-.993",
    transform: "translate(-24.184 -16.912)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_140215",
    "data-name": "Path 140215",
    d: "M77,49.966h.794v.463a.839.839,0,0,1,.926-.529v.662h-.2a.924.924,0,0,0-.6.2.878.878,0,0,0-.2.662v1.324H77Z",
    transform: "translate(-26.044 -16.878)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_140216",
    "data-name": "Path 140216",
    d: "M82.153,49.391h.926l-1.125,1.191,1.257,1.654h-.993l-1.125-1.522v1.522H80.3V48.2h.794v2.382Z",
    transform: "translate(-27.16 -16.303)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_140217",
    "data-name": "Path 140217",
    d: "M88.29,52.1H87.5v-2.25h-.6v-.529h.6v-.529c0-.529.265-.794.993-.794h.463v.529h-.132c-.331,0-.463.066-.463.4v.4h.662v.529h-.662V52.1Z",
    transform: "translate(-29.393 -16.235)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_140218",
    "data-name": "Path 140218",
    d: "M91.756,52.912A1.39,1.39,0,0,1,90.3,51.456a1.491,1.491,0,1,1,1.456,1.456m.066-2.449c-.463,0-.662.331-.662.926,0,.662.265.993.662.993s.662-.331.662-.926c0-.662-.265-.993-.662-.993",
    transform: "translate(-30.543 -16.912)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_140219",
    "data-name": "Path 140219",
    d: "M95.766,49.966h.794v.463a.839.839,0,0,1,.926-.529v.662h-.2a.924.924,0,0,0-.6.2.878.878,0,0,0-.2.662v1.324H95.7V49.966Z",
    transform: "translate(-32.369 -16.878)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_140220",
    "data-name": "Path 140220",
    d: "M102.093,52.912a.874.874,0,0,1-.993-.86.942.942,0,0,1,.6-.86,3.933,3.933,0,0,1,1.125-.132h.132v-.132c0-.4-.132-.529-.529-.529-.331,0-.463.132-.529.463h-.728c0-.6.4-.86,1.191-.86.86,0,1.324.331,1.324.993v1.919h-.662v-.4a1.2,1.2,0,0,1-.926.4m.662-1.456c-.662,0-.926.132-.926.529a.418.418,0,0,0,.463.463c.463,0,.662-.265.662-.86v-.066a.243.243,0,0,0-.2-.066",
    transform: "translate(-34.196 -16.912)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_140221",
    "data-name": "Path 140221",
    d: "M109.128,49.688a.866.866,0,0,1,.794-.4c.728,0,1.257.6,1.257,1.522,0,.86-.463,1.39-1.191,1.39a.887.887,0,0,1-.86-.529v.463H108.4V48.1h.794v1.588Zm.6.066c-.4,0-.6.331-.6.926,0,.728.2,1.059.662,1.059.4,0,.6-.331.6-.926v-.066c0-.662-.2-.993-.662-.993",
    transform: "translate(-36.665 -16.269)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_140222",
    "data-name": "Path 140222",
    d: "M114.228,51.621c0,.463.265.794.662.794a.535.535,0,0,0,.6-.529h.728c0,.6-.529.993-1.257.993-.662,0-1.125-.2-1.324-.728a1.309,1.309,0,0,1-.132-.728,1.359,1.359,0,0,1,1.39-1.522,1.276,1.276,0,0,1,1.39,1.456v.132h-2.051Zm.662-1.257c-.4,0-.6.265-.662.728h1.191c0-.463-.2-.728-.529-.728",
    transform: "translate(-38.39 -16.878)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_140223",
    "data-name": "Path 140223",
    d: "M119.524,51.479c0,.331.132.463.4.463h.331v.463a3.039,3.039,0,0,1-.662.066.809.809,0,0,1-.6-.2.956.956,0,0,1-.2-.728V50.09h-.6V49.56h.6V49.1l.728-.4v.86h.728v.529h-.728v1.39",
    transform: "translate(-39.979 -16.472)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_140224",
    "data-name": "Path 140224",
    d: "M123.124,51.479c0,.331.132.463.4.463h.331v.463a3.039,3.039,0,0,1-.662.066.809.809,0,0,1-.6-.2.956.956,0,0,1-.2-.728V50.09h-.6V49.56h.6V49.1l.728-.4v.86h.728v.529h-.728v1.39",
    transform: "translate(-41.197 -16.472)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_140225",
    "data-name": "Path 140225",
    d: "M126.228,51.621c0,.463.265.794.662.794a.535.535,0,0,0,.6-.529h.728c0,.6-.529.993-1.257.993-.662,0-1.125-.2-1.324-.728a1.309,1.309,0,0,1-.132-.728,1.359,1.359,0,0,1,1.39-1.522,1.276,1.276,0,0,1,1.39,1.456v.132h-2.051Zm.662-1.257c-.4,0-.6.265-.662.728h1.191c.066-.463-.2-.728-.529-.728",
    transform: "translate(-42.449 -16.878)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_140226",
    "data-name": "Path 140226",
    d: "M130.566,49.966h.794v.463a.839.839,0,0,1,.926-.529v.662h-.2a.924.924,0,0,0-.6.2.878.878,0,0,0-.2.662v1.324H130.5V49.966Z",
    transform: "translate(-44.14 -16.878)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_140227",
    "data-name": "Path 140227",
    d: "M139.737,52.779h-.86l-.662-1.985-.662,1.985h-.86L135.7,50h.86l.662,1.919L137.884,50h.86l.662,1.919L140.068,50h.728Z",
    transform: "translate(-45.899 -16.912)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_140228",
    "data-name": "Path 140228",
    d: "M145.156,52.912a1.39,1.39,0,0,1-1.456-1.456,1.491,1.491,0,1,1,1.456,1.456m.066-2.449c-.463,0-.662.331-.662.926,0,.662.265.993.662.993s.662-.331.662-.926c0-.662-.265-.993-.662-.993",
    transform: "translate(-48.604 -16.912)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_140229",
    "data-name": "Path 140229",
    d: "M149.166,49.966h.794v.463a.839.839,0,0,1,.926-.529v.662h-.2a.924.924,0,0,0-.6.2.878.878,0,0,0-.2.662v1.324H149.1V49.966Z",
    transform: "translate(-50.431 -16.878)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4666",
    "data-name": "Rectangle 4666",
    width: 0.794,
    height: 4.037,
    transform: "translate(100.919 31.831)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_140230",
    "data-name": "Path 140230",
    d: "M157.546,52.1h-.794v-.4a.964.964,0,0,1-.86.463c-.728,0-1.191-.6-1.191-1.522,0-.86.463-1.456,1.191-1.456a.9.9,0,0,1,.86.463V48h.794Zm-1.456-.4c.4,0,.662-.331.662-.926a1.29,1.29,0,0,0-.066-.529.7.7,0,0,0-.6-.529c-.4,0-.662.331-.662.926v.066c.066.662.265.993.662.993",
    transform: "translate(-52.325 -16.235)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_140231",
    "data-name": "Path 140231",
    d: "M57.06,42.337H56.2L57.788,38.3h1.059l1.522,4.037h-.86l-.331-.86H57.391Zm1.919-1.522L58.318,38.9l-.662,1.919Z",
    transform: "translate(-19.009 -12.954)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_140232",
    "data-name": "Path 140232",
    d: "M66.09,42.3H65.3v-2.25h-.6v-.529h.6v-.529c0-.529.265-.794.993-.794h.463v.529h-.132c-.331,0-.463.066-.463.4v.4h.662v.529h-.662V42.3Z",
    transform: "translate(-21.884 -12.921)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_140233",
    "data-name": "Path 140233",
    d: "M69.093,43.112a.874.874,0,0,1-.993-.86.942.942,0,0,1,.6-.86,3.934,3.934,0,0,1,1.125-.132h.2v-.132c0-.4-.132-.529-.529-.529-.331,0-.463.132-.529.463h-.728c0-.6.4-.86,1.191-.86.86,0,1.324.331,1.324.993v1.919h-.662v-.4a1.248,1.248,0,0,1-.993.4m.728-1.456c-.662,0-.926.132-.926.529a.418.418,0,0,0,.463.463c.463,0,.662-.265.662-.86v-.066a.243.243,0,0,0-.2-.066",
    transform: "translate(-23.034 -13.597)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_140234",
    "data-name": "Path 140234",
    d: "M73.3,40.166h.794v.463a1.056,1.056,0,0,1,.926-.529.852.852,0,0,1,.86.529,1.056,1.056,0,0,1,.926-.529c.662,0,.993.4.993,1.125v1.721h-.728V41.291c0-.463-.132-.728-.529-.728s-.6.265-.6.86v1.456h-.728V41.093c0-.4-.2-.6-.529-.6q-.6,0-.6.794v1.588H73.3V40.166",
    transform: "translate(-24.793 -13.563)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_140235",
    "data-name": "Path 140235",
    d: "M82.128,39H81.4v-.6h.728Zm0,3.375H81.4V39.591h.728Z",
    transform: "translate(-27.532 -12.988)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4667",
    "data-name": "Rectangle 4667",
    width: 0.794,
    height: 4.037,
    transform: "translate(55.324 25.346)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_140236",
    "data-name": "Path 140236",
    d: "M86.922,44.038h-.728l.463-1.059L85.4,40.2h.86l.728,1.919L87.65,40.2h.794c-.728,1.853-.926,2.25-1.522,3.838",
    transform: "translate(-28.885 -13.597)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_140237",
    "data-name": "Path 140237",
    d: "M95.347,42.053a1.143,1.143,0,0,1-1.257,1.059,1.286,1.286,0,0,1-1.39-1.39A1.344,1.344,0,0,1,94.156,40.2a1.1,1.1,0,0,1,1.257,1.059h-.728c-.066-.4-.2-.529-.529-.529-.463,0-.662.265-.662.926,0,.728.2,1.125.662,1.125.331,0,.529-.2.529-.6v-.066Z",
    transform: "translate(-31.354 -13.597)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_140238",
    "data-name": "Path 140238",
    d: "M98.756,43.112A1.39,1.39,0,0,1,97.3,41.656a1.491,1.491,0,1,1,1.456,1.456m.066-2.449c-.463,0-.662.331-.662.926,0,.662.265.993.662.993s.662-.331.662-.926c0-.662-.265-.993-.662-.993",
    transform: "translate(-32.91 -13.597)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_140239",
    "data-name": "Path 140239",
    d: "M102.766,40.166h.794v.463a1.056,1.056,0,0,1,.926-.529.852.852,0,0,1,.86.529,1.056,1.056,0,0,1,.926-.529c.662,0,.993.4.993,1.125v1.721h-.794V41.291c0-.463-.132-.728-.529-.728s-.6.265-.6.86v1.456h-.728V41.093c0-.4-.2-.6-.529-.6q-.6,0-.6.794v1.588H102.7V40.166Z",
    transform: "translate(-34.737 -13.563)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_140240",
    "data-name": "Path 140240",
    d: "M111.594,44H110.8V40.166h.794v.4a.9.9,0,0,1,.86-.463c.728,0,1.191.529,1.191,1.39,0,.926-.529,1.522-1.257,1.522a.943.943,0,0,1-.794-.4V44m.662-3.375c-.463,0-.662.331-.662.926,0,.662.2.993.662.993s.662-.4.662-.993c-.066-.6-.265-.926-.662-.926",
    transform: "translate(-37.476 -13.563)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_140241",
    "data-name": "Path 140241",
    d: "M116.893,43.112a.874.874,0,0,1-.993-.86.942.942,0,0,1,.6-.86,3.934,3.934,0,0,1,1.125-.132h.132v-.132c0-.4-.132-.529-.529-.529-.331,0-.463.132-.529.463h-.728c0-.6.4-.86,1.191-.86.86,0,1.324.331,1.324.993v1.919h-.662v-.4a1.2,1.2,0,0,1-.926.4m.662-1.456c-.662,0-.926.132-.926.529a.418.418,0,0,0,.463.463c.463,0,.662-.265.662-.86v-.066a.243.243,0,0,0-.2-.066",
    transform: "translate(-39.201 -13.597)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_140242",
    "data-name": "Path 140242",
    d: "M121,40.166h.794v.463a1.167,1.167,0,0,1,.993-.529.905.905,0,0,1,.993.993v1.919h-.794V41.357c0-.463-.132-.662-.529-.662a.645.645,0,0,0-.662.728v1.588H121Z",
    transform: "translate(-40.926 -13.563)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_140243",
    "data-name": "Path 140243",
    d: "M127.322,44.038h-.728l.463-1.059L125.8,40.2h.86l.728,1.919.662-1.919h.728c-.662,1.853-.86,2.25-1.456,3.838",
    transform: "translate(-42.55 -13.597)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_140244",
    "data-name": "Path 140244",
    d: "M66.093,14.483a4.989,4.989,0,0,0-2.846-1.125,7.916,7.916,0,0,0-1.654-.066,7.916,7.916,0,0,0-1.654.066,5.723,5.723,0,0,0-2.846,1.125,3.376,3.376,0,0,0-.993,2.25v6.419a2.866,2.866,0,0,0,.993,2.25,4.989,4.989,0,0,0,2.846,1.125,7.926,7.926,0,0,0,1.654.066h.331a8.89,8.89,0,0,0,1.257-.066A5.723,5.723,0,0,0,66.026,25.4a3.376,3.376,0,0,0,.993-2.25V16.733a3.042,3.042,0,0,0-.926-2.25m-3.309,9.132a1.191,1.191,0,1,1-2.382,0V16.137a1.191,1.191,0,1,1,2.382,0Z",
    transform: "translate(-18.975 -4.49)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_140245",
    "data-name": "Path 140245",
    d: "M140.193,14.483a4.989,4.989,0,0,0-2.846-1.125,20.714,20.714,0,0,0-3.309,0,5.723,5.723,0,0,0-2.846,1.125,3.376,3.376,0,0,0-.993,2.25v6.419a2.866,2.866,0,0,0,.993,2.25,4.989,4.989,0,0,0,2.846,1.125,7.926,7.926,0,0,0,1.654.066h.331a8.89,8.89,0,0,0,1.257-.066,5.723,5.723,0,0,0,2.846-1.125,3.376,3.376,0,0,0,.993-2.25V16.733a2.62,2.62,0,0,0-.926-2.25m-3.309,9.132a1.191,1.191,0,1,1-2.382,0V16.137a1.191,1.191,0,1,1,2.382,0Z",
    transform: "translate(-44.038 -4.49)"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgScJohnsonLogo);
export default __webpack_public_path__ + "static/media/sc-johnson-logo.90374c7807a97867feee78ed854a0ac6.svg";
export { ForwardRef as ReactComponent };